import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-brown text-white/60 text-center" data-id="element-52">
      <div className="max-w-4xl mx-auto" data-id="element-53">
        <p className="text-sm" data-id="element-54">
          Este plan no reemplaza consulta médica profesional.
        </p>
        <p className="text-sm mt-4" data-id="element-55">
          © {new Date().getFullYear()} Plan Pancita Desinflamada
        </p>
      </div>
    </footer>;
}